import { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styleListData from "./paymentUnderAccount.module.css";

import MainContent from "../../../layouts/maincontent/MainContent";

import LoadingSpinner from "../../../components/Loading/LoadingSpinner";
import disputeInfo from "../../../assets/img/Icon feather-file-text.png";
// import walletAdd from "../../../assets/img/Wallet-pana.png";

import { useLocation } from "react-router-dom";
import { get, post } from "../../../adapters/xhr/api";
import Pagination, {
  PaginationTax,
} from "../../../shared/pagination/Pagination";
import Claims from "../claims";

const PaymentUnderAccountDebt = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [units, setUnits] = useState([]);
  const [staticWallet, setStaticWallet] = useState(0);
  const [walletInitialized, setWalletInitialized] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [backendError, setBackendError] = useState(null);

  const [isAllChecked, setIsAllChecked] = useState(false);
  const [isSubmitButtonActive, setIsSubmitButtonActive] = useState(false);
  const [activeTab, setActiveTab] = useState("payments");
  const [declarationStatus, setDeclarationStatus] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  const [error, setError] = useState(null);

  const [pagination, setPagination] = useState(null);
  const [limit, setLimit] = useState(20);

  // selectedUnits tracks all selected units across ALL pages
  // Each entry: { id, type, property_type_id, amount_under_payment, paid_by_wallet }
  const [selectedUnits, setSelectedUnits] = useState([]);

  // Derive wallet balance: staticWallet minus total of all wallet selections
  const wallet = useMemo(() => {
    const totalDeductions = selectedUnits.reduce(
      (sum, unit) =>
        sum +
        (unit.paid_by_wallet ? Number(unit.amount_under_payment) || 0 : 0),
      0,
    );

    return staticWallet - totalDeductions;
  }, [staticWallet, selectedUnits]);

  useEffect(() => {
    if (location?.state?.activeTab) {
      setActiveTab(location?.state?.activeTab);
    }
  }, [location]);

  useEffect(() => {
    setIsAllChecked(false);
    setSelectedUnits([]);
    setUnits((prevUnits) =>
      prevUnits.map((unit) =>
        unit?.is_exist_in_claim === false
          ? {
              ...unit,
              is_checked: false,
              is_paid_by_wallet_disabled: true,
              paid_by_wallet: false,
            }
          : unit,
      ),
    );
  }, [activeTab]);

  const getPaymentUnderAccountUnitsList = async (
    page = 1,
    newLimit,
    isFirstLoad = false,
  ) => {
    try {
      const perPage = newLimit || limit;

      // Build URL conditionally
      let url = `api/declaration-system/UnderDeclarationProperties/list/${id}?page=${page}`;
      if (!isFirstLoad) {
        url += `&per_page=${perPage}`;
      }

      const response = await get(url);

      const fetchedUnits = response?.data?.data?.data || [];

      const processedUnits = fetchedUnits.map((unit) => {
        const unitKey = `${unit.id}-${unit.type}`;
        const existingSelection = selectedUnits.find(
          (wu) => `${wu.id}-${wu.type}` === unitKey,
        );

        if (isAllChecked && unit.is_exist_in_claim === false) {
          return {
            ...unit,
            is_checked: true,
            is_paid_by_wallet_disabled: false,
            paid_by_wallet: existingSelection
              ? existingSelection.paid_by_wallet
              : false,
          };
        }

        if (existingSelection) {
          return {
            ...unit,
            is_checked: true,
            is_paid_by_wallet_disabled: false,
            paid_by_wallet: existingSelection.paid_by_wallet,
          };
        }

        return unit;
      });

      setUnits(processedUnits);
      setPagination(response?.data?.data?.pagination);
      setLimit(response?.data?.data?.pagination?.per_page);
      setDeclarationStatus(parseInt(response?.data?.declaration_status_id));

      if (!walletInitialized) {
        setStaticWallet(response?.data?.wallet_balance);
        setWalletInitialized(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (activeTab === "payments") {
      getPaymentUnderAccountUnitsList(1, limit, true);
    }
  }, [activeTab]);

  const handlePageChange = (page) => {
    getPaymentUnderAccountUnitsList(page, limit);
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    getPaymentUnderAccountUnitsList(1, newLimit);
  };

  useEffect(() => {
    setUnits((prevUnits) =>
      prevUnits.map((unit) =>
        unit?.is_exist_in_claim === false
          ? {
              ...unit,
              is_checked: isAllChecked,
              is_paid_by_wallet_disabled: !isAllChecked,
              paid_by_wallet: false,
            }
          : unit,
      ),
    );
    // Clear all cross-page selections when toggling isAllChecked
    setSelectedUnits([]);
  }, [isAllChecked]);

  useEffect(() => {
    setIsSubmitButtonActive(
      isAllChecked ||
        units
          ?.filter((unit) => unit?.is_exist_in_claim === false)
          .some((unit) => unit?.is_checked === true),
    );
  }, [units, isAllChecked]);

  const handleIsCheckedChange = (unit, e) => {
    const checkValue = e.target.checked;
    const unitKey = `${unit.id}-${unit.type}`;

    if (!checkValue) {
      // Remove from selectedUnits
      setSelectedUnits((prev) =>
        prev.filter((wu) => `${wu.id}-${wu.type}` !== unitKey),
      );
      setUnits((prev) => {
        const newUnitsArray = prev.map((u) =>
          u?.id == unit?.id && u?.type == unit?.type
            ? {
                ...u,
                is_checked: checkValue,
                is_paid_by_wallet_disabled: true,
                paid_by_wallet: false,
              }
            : u,
        );
        return newUnitsArray;
      });
    } else {
      // Add to selectedUnits with paid_by_wallet: false
      setSelectedUnits((prev) => {
        const alreadyExists = prev.some(
          (wu) => `${wu.id}-${wu.type}` === unitKey,
        );
        if (alreadyExists) return prev;
        return [
          ...prev,
          {
            id: unit.id,
            type: unit.type,
            property_type_id: unit.property_type_id,
            amount_under_payment: unit.amount_under_payment,
            paid_by_wallet: false,
          },
        ];
      });
      setUnits((prev) => {
        const newUnitsArray = prev.map((u) =>
          u?.id == unit?.id && u?.type == unit?.type
            ? {
                ...u,
                is_checked: checkValue,
                is_paid_by_wallet_disabled: false,
              }
            : u,
        );
        return newUnitsArray;
      });
    }
  };

  const handleIsPaidByWalletChange = (unit, e) => {
    const checkedValue = e.target.checked;
    const walletKey = `${unit.id}-${unit.type}`;
    const amount = Number(unit?.amount_under_payment) || 0;

    if (checkedValue) {
      // wallet already represents the remaining balance
      if (wallet < amount) {
        return;
      }

      setSelectedUnits((prev) => {
        const exists = prev.some((wu) => `${wu.id}-${wu.type}` === walletKey);

        if (exists) {
          return prev.map((wu) =>
            `${wu.id}-${wu.type}` === walletKey
              ? { ...wu, paid_by_wallet: true }
              : wu,
          );
        }

        return [...prev, { ...unit, paid_by_wallet: true }];
      });

      setUnits((prev) =>
        prev.map((u) =>
          u.id === unit.id && u.type === unit.type
            ? { ...u, paid_by_wallet: true }
            : u,
        ),
      );
    } else {
      setSelectedUnits((prev) =>
        prev.map((wu) =>
          `${wu.id}-${wu.type}` === walletKey
            ? { ...wu, paid_by_wallet: false }
            : wu,
        ),
      );

      setUnits((prev) =>
        prev.map((u) =>
          u.id === unit.id && u.type === unit.type
            ? { ...u, paid_by_wallet: false }
            : u,
        ),
      );
    }
  };

  const data =
    units?.length > 0 &&
    units?.map((element, index) => (
      <tr
        key={`${element?.id}-${element?.type}-${index}`}
        className={` ${element?.is_exist_in_claim && "opacity-50"}`}
      >
        <td data-label="">
          <input
            type="checkbox"
            className={`form-check-input ${styleListData["checkboxEnabled"]}`}
            checked={!!element?.is_checked}
            onChange={(e) => handleIsCheckedChange(element, e)}
            style={{ marginRight: "10px" }}
            aria-label="تحديد الصف"
            disabled={element?.is_exist_in_claim || isAllChecked}
          />
        </td>

        <td data-label="المحافظة">{element?.governorate || "-"}</td>
        <td data-label="عنوان العقار">
          {element?.correct_astrick_colour && (
            <span className={`${element?.correct_astrick_colour} mr-1`}>*</span>
          )}

          {element?.full_address}
        </td>

        <td data-label="نوع العقار">{element?.property_type || "-"}</td>

        <td data-label="رقم العقار">{element?.property_number || "-"}</td>

        <td data-label="رقم الوحدة">{element?.unit_number || "-"}</td>

        <td data-label="اسم المنشأة / النشاط التجاري">
          {element?.property_name || "-"}
        </td>

        <td data-label="نوع نشاط المنشأة/ الوحدة">
          {element?.activity_type || "-"}
        </td>

        {/* SMALL COLUMNS (width controlled by colgroup) */}
        <td data-label="المبلغ تحت الحساب">
          <span
            className="p-2 rounded"
            style={{ backgroundColor: "#F5F5F5", border: "1px solid #CFCFCF" }}
          >
            {element?.amount_under_payment ?? "0"}
          </span>
        </td>

        <td data-label="المبلغ الجاري سداده">
          <span
            className="p-2 rounded"
            style={{ backgroundColor: "#F5F5F5", border: "1px solid #CFCFCF" }}
          >
            {element?.required_amount ?? "0"}
          </span>
        </td>

        <td data-label="المبلغ المسدد">
          <span
            className="p-2 rounded"
            style={{ backgroundColor: "#F5F5F5", border: "1px solid #CFCFCF" }}
          >
            {element?.paid_amount ?? "0"}
          </span>
        </td>
        {/* <td data-label="السداد من حساب التسويات">
          <input
            type="checkbox"
            className={`form-check-input ${element?.is_paid_by_wallet_disabled ? styleListData["checkboxDisabled"] : styleListData["checkboxEnabled"]}`}
            checked={!!element?.paid_by_wallet}
            disabled={
              element?.is_paid_by_wallet_disabled || element?.is_exist_in_claim
            }
            onChange={(e) => handleIsPaidByWalletChange(element, e)}
            aria-label="سداد من حساب التسويات"
          />
        </td> */}
      </tr>
    ));

  const handleSubmit = async () => {
    try {
      setBackendError(null);
      setIsSubmitting(true);
      let unitsToBeSubmitted = units
        ?.filter(
          (unit) =>
            unit?.is_checked === true && unit?.is_exist_in_claim === false,
        )
        ?.map((unit) => ({
          id: unit?.id,
          property_type_id: unit?.property_type_id,
          paid_by_wallet: unit?.paid_by_wallet,
        }));
      const data = {
        declaration_id: id,
        property_data: selectedUnits,
        is_all_checked: isAllChecked,
      };

      let url = `api/declaration-system/declarations/user/claim`;

      await post(
        url,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
        data,
      );
      // Reset wallet state after successful submit
      setSelectedUnits([]);
      setWalletInitialized(false);
      // getPaymentUnderAccountUnitsList();
      setActiveTab("claims");
      setIsSubmitting(false);
    } catch (error) {
      setBackendError(
        error.response?.data?.message ||
          error.response?.data?.data?.message ||
          "لا توجد عقارات لإصدار طلب سداد عنها",
      );
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <MainContent>
        {backendError && (
          <div
            className="alert alert-danger mt-3 w-75 mx-auto"
            id="backend_error"
            role="alert"
          >
            {backendError}
          </div>
        )}
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <section className={`${styleListData.listData}`}>
              <div className="container pt-4">
                <div className={styleListData.box}>
                  <div className={`${styleListData["box-header"]}`}>
                    <div className="d-flex align-items-center flex-wrap">
                      <Link
                        className={`${styleListData["btn-arrow"]} ms-3`}
                        to={`/tax-declaration/list-data`}
                      >
                        <i className="fa-solid fa-arrow-right mt-1"></i>
                      </Link>

                      {/* Responsive Tabs */}
                      <div className={`ms-2 ${styleListData["tabs-wrapper"]}`}>
                        <div
                          className={`${styleListData["tab-item"]} ${
                            activeTab === "payments"
                              ? styleListData["active"]
                              : ""
                          }`}
                          onClick={() => setActiveTab("payments")}
                        >
                          <h3 className="mb-0 ms-2 fw-bold">
                            بيانات الدفع تحت الحساب
                          </h3>
                        </div>

                        <div
                          className={`${styleListData["tab-item"]} ${
                            activeTab === "claims"
                              ? styleListData["active"]
                              : ""
                          }`}
                          onClick={() => setActiveTab("claims")}
                        >
                          <h3 className="mb-0 ms-2 fw-bold">طلبات السداد</h3>
                        </div>
                      </div>
                    </div>

                    {activeTab === "payments" && (
                      <div>
                        {[2, 3].includes(declarationStatus) && (
                          <button
                            className={`${
                              isSubmitButtonActive
                                ? styleListData["btn-request"]
                                : styleListData["btn-request-disabled"]
                            }`}
                            id="add_declaration_button"
                            onClick={handleSubmit}
                            disabled={isSubmitting}
                          >
                            إصدار طلب سداد
                          </button>
                        )}
                      </div>
                    )}
                  </div>

                  {location?.state?.message && (
                    <div className="alert alert-danger mt-2 text-center w-25 mx-auto">
                      <h3 className="fs-5">{location?.state?.message} </h3>
                    </div>
                  )}

                  <div>
                    {activeTab === "payments" && (
                      <>
                        <div className="d-flex align-items-center mt-5 me-3">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={isAllChecked}
                            onChange={() => setIsAllChecked(!isAllChecked)}
                            aria-label="تحديد الصف"
                          />

                          <h4 className="mb-0 me-2 fw-bold">
                            سداد بالكامل عن كافة العقارات
                          </h4>
                        </div>

                        <div className={`${styleListData["box-body"]}  mt-3`}>
                          <div
                            className={`${styleListData["table-responsive"]} table-responsive `}
                          >
                            <table
                              className={`${styleListData["table"]} table`}
                            >
                              <thead>
                                <tr>
                                  <th scope="col"></th>
                                  <th scope="col">المحافظة</th>
                                  <th scope="col">عنوان العقار</th>
                                  <th scope="col">نوع العقار</th>
                                  <th scope="col">رقم العقار</th>
                                  <th scope="col">رقم الوحدة</th>
                                  <th scope="col">
                                    اسم المنشأة / النشاط التجاري
                                  </th>
                                  <th scope="col">نوع نشاط المنشأة/ الوحدة</th>
                                  <th scope="col">المبلغ تحت الحساب</th>
                                  <th scope="col">المبلغ الجاري سداده</th>
                                  <th scope="col">المبلغ المسدد</th>
                                  {/* <th scope="col">السداد من حساب التسويات</th> */}
                                </tr>
                              </thead>

                              <tbody>
                                {data?.length > 0 ? (
                                  data
                                ) : (
                                  <tr>
                                    <td colSpan={10} className="h5 text-center">
                                      {error}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        {pagination && (
                          <PaginationTax
                            limit={limit}
                            count={pagination?.total}
                            active={pagination?.current_page}
                            callback={handlePageChange}
                            handleLimitChange={handleLimitChange}
                          />
                        )}
                      </>
                    )}

                    {activeTab === "claims" && (
                      <>
                        {/* Put your claims tab content here */}
                        <Claims />
                        {/* <div className="text-center text-muted py-4">
                            <h5>لا توجد طلبات سداد حالياً</h5>
                          </div> */}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </section>
          </>
        )}
      </MainContent>
    </>
  );
};

export default PaymentUnderAccountDebt;
